import { Typography, useTheme } from "@mui/material";
import { useMemo } from "react";

interface ActivityDetailsText {
  children?: React.ReactNode;
}
const ActivityDetailsText = ({ children }: ActivityDetailsText) => {
  const theme = useTheme();

  const typographyStyles = useMemo(() => {
    return {
      ...theme.nawy.typography.english.variants.body.md.regular,
      color: theme.nawy.colors.semantic.text.primary,
    };
  }, [theme]);

  return <Typography sx={typographyStyles}>{children}</Typography>;
};
export default ActivityDetailsText;
